import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "F:/Programacion/reactworkshop/src/components/Layout.js";
import { Link } from 'gatsby';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>{`Workshop de React`}</h1>
    <p>{`En este workshop, vamos a aprender y entender las bases de React haciendo una
app que nos muestre el clima en alguna ciudad. `}{`(`}{`Buenos Aires en el ejemplo pero
pueden cambiarlo por la ciudad donde viven 😀`}{`)`}</p>
    <p>{`La idea es empezar viendo la intro que posee data adicional en las notas para
presentación `}{`(`}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Alt + P`}</code>{`)`}</p>
    <p><a parentName="p" {...{
        "href": "https://mini-introreact.netlify.com/"
      }}>{`Click para ver la presentación ⚛️`}</a></p>
    <p>{`Luego, si queremos ampliar los 4 conceptos fundamentales, en cada uno de estos
links hay teoría para profundizar sobre cada tema:`}</p>
    <p>{`(`}<em parentName="p">{`por ahora son links directos a la página de Flavio Copes en inglés, la idea
es ir traduciendo a español el contenido, ya hablé con él y me dio permiso para
hacerlo`}</em>{` 😀`}{`)`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://flaviocopes.com/react-components/"
        }}>{`Componentes`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://flaviocopes.com/jsx/"
        }}>{`JSX`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://flaviocopes.com/react-props/"
        }}>{`Props`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://flaviocopes.com/react-state/"
        }}>{`State`}</a></li>
    </ul>
    <p><strong parentName="p">{`Navegación por el workshop:`}</strong>{` Como verán si van para abajo de todo, hay
botones para ir al próximo paso, para hacer las cosas en orden. Si ya están
avanzados tienen a la izquierda el menú (o en un botón arriba si están viendo
esto en mobile).`}</p>
    <p>{`Y este es un temario con lo que vamos a ver en cada paso del workshop:`}</p>
    <ol>
      <li parentName="ol">
        <Link to="/intro" mdxType="Link">Intro</Link>: Qué es un componente, nuestro primer componente. Conceptos
como componente funcional y de clase, qué es el DOM (en un link externo súper completo).
      </li>
      <li parentName="ol">
        <Link to="/props-y-state" mdxType="Link">Props y State</Link>: Conceptos de props y state, fundamentales 
para el manejo de datos en React.
      </li>
      <li parentName="ol">
        <Link to="/paso-01" mdxType="Link">Workshop - Paso 1</Link>: Ciclos de vida de componentes, variables de 
entorno, template strings, uso de fetch(), destructuring, conditional rendering, manipulando 
el state con setState.
      </li>
      <li parentName="ol">
        <Link to="/paso-02" mdxType="Link">Workshop - Paso 2</Link>: División en componentes, iteración de 
componentes.
      </li>
      <li parentName="ol">
        <Link to="/paso-03" mdxType="Link">Workshop - Paso 3</Link>: Creando una Lambda Function para nuestro 
"backend", deploy de nuestra app en Netlify, resguardo de API key.
      </li>
    </ol>
    <hr></hr>
    <h2>{`Créditos`}</h2>
    <p>{`Fuentes usadas para hacer este workshop:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://flaviocopes.com/react/"
        }}>{`Tutorial de React de Flavio Copes`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://reactjs.org/docs/getting-started.html"
        }}>{`Documentación de React`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.mozilla.org/es/docs/Web"
        }}>{`MDN web docs`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://code.tutsplus.com/tutorials/stateful-vs-stateless-functional-components-in-react--cms-29541"
        }}>{`Stateful vs. Stateless Functional Components in React (envatotuts+)`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/facebook/create-react-app"
        }}>{`Create-React-App (Repo)`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/atomiks/tippyjs/tree/master/website"
        }}>{`Documentación de Tippy.js usada como plantilla de Gatsby+MDX`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      